import { Grid2 as Grid, Box, Stepper, Step, StepButton, Button, Stack } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { NotificationFormProps } from "./types";
import { useNotificationForm } from "./controller";
import { RecipientsStep, MessageStep, ScheduleStep, ReviewStep } from "./Steps";

export function NotificationForm({ onSubmit, isSubmitting }: NotificationFormProps) {
  const translate = useTranslate();
  const { steps, activeStep, maxVisitedStep, isLastStep, handleStep, handleNext, handleBack } =
    useNotificationForm();

  return (
    <Box component="form" onSubmit={(event) => event.preventDefault()}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12 }}>
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={label} completed={index < maxVisitedStep && index !== activeStep}>
                <StepButton onClick={handleStep(index)} disabled={index > maxVisitedStep}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>

        <Grid size={{ xs: 12 }}>
          {activeStep === 0 && <RecipientsStep />}
          {activeStep === 1 && <MessageStep />}
          {activeStep === 2 && <ScheduleStep />}
          {activeStep === 3 && <ReviewStep />}
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button disabled={activeStep === 0 || isSubmitting} onClick={handleBack} variant="outlined">
              {translate("buttons.back")}
            </Button>

            {isLastStep ? (
              <Button variant="contained" onClick={onSubmit} loading={isSubmitting}>
                {translate("notifications_emails_admin.buttons.schedule")}
              </Button>
            ) : (
              <Button variant="contained" onClick={handleNext}>
                {translate("buttons.next")}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
